export const SUBMIT_CREATE_UGC_DRAFT_CLICK = 'w:Submit:AddUGCDraft:click';
export const SUBMIT_CREATE_UGC_DRAFT_CANCEL_CLICK =
  'w:Submit:AddUGCDraft:Cancel:click';
